export default __webpack_public_path__ + "static/media/wgt-firm-logo.8b4e55cd.png";